export const SET_LIST_DATA = (prefix) => `SET_${prefix}_LIST_DATA`;

export const APPEND_TO_LIST_DATA = (prefix) => `APPEND_TO_${prefix}_LIST_DATA`;

export const SET_LIST_PAGINATION_METADATA = (prefix) =>
  `SET_${prefix}_LIST_PAGINATION_METADATA`;

export const SET_LIST_IS_LOADING = (prefix) => `SET_${prefix}_LIST_IS_LOADING`;
